<template>
  <div>
    <h1 class="text-uppercase mb-1 text-center">Next drawing in</h1>
    <v-fade-transition mode="out-in">
      <div
        v-if="upcomingSortition.status === contentStatus.loading"
        :key="'loading-icon'"
        class="d-flex justify-center"
      >
        <font-awesome-icon spin icon="sync" size="3x"></font-awesome-icon>
      </div>
      <div
        v-else-if="upcomingSortition.status === contentStatus.loaded"
        :key="'upcoming-sortition'"
      >
        <template v-if="upcomingSortition.sortition">
          <h2 id="next-result">{{ upcomingSortition.sortition.name }}</h2>
          <div id="countdown">{{ timeLeft }}</div>
        </template>
        <template v-else>
          <h2>No sortition found.</h2>
        </template>
      </div>
    </v-fade-transition>
  </div>
</template>

<script>
import BaseUpcomingSortition from "../BaseUpcomingSortition";

export default {
  name: "UpcomingSortition",
  extends: BaseUpcomingSortition
};
</script>

<style scoped>
#next-result {
  font-size: 1.8rem;
  line-height: 30px;
  text-align: center;
}

#countdown {
  font-weight: bold;
  font-size: 2.4rem;
  text-align: center;
  color: #c11d1e;
}
</style>
